import { apiCallback } from '@vantiva-sa/homesight_humaui/Services/Common';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';
import { useSelector } from 'react-redux';
import { useApiMutation } from './useApiMutation';

const useApplyInsightRule = (options = {}) => {
  const trans = useSelector(translator);
  const insightRulesApi = useSelector((state) => state.apis.insightRulesApi);
  const { ...mutationOptions } = options;

  return useApiMutation(
    ({ requestBody, successCallback, errorCallback, useruuid }) =>
      new Promise((resolve, reject) => {
        insightRulesApi.applyInsightRule(
          useruuid,
          requestBody,
          apiCallback({
            translator: trans,
            successCallback: (data) => {
              successCallback(data);
              resolve(data);
            },
            errorCallback: (err) => {
              errorCallback(err);
              reject(err);
            },
          })
        );
      }),
    {
      ...mutationOptions,
      invalidateKeys: [['getInsightRules']],
    }
  );
};

export default useApplyInsightRule;
